import React from "react";

export function showError(error) {
  return (error !== "") & (error !== "true") ? (
    <span id="exampleInputEmail1-error" className="error invalid-feedback">
      {error}
    </span>
  ) : (
    ""
  );
}

export function errorClass(error) {
  return (error !== "") & (error !== "true")
    ? "form-control is-invalid"
    : "form-control";
}
